import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  background: ${props => props.theme.orange || `orange`};
  color: #333;
  padding: 15px 25px;
  text-align: center;
  border: 0;
`;

const Button = props => {
  return <StyledButton>{props.children}</StyledButton>;
};

export default Button;
